export const ServiceCallApplySceneTranslation = {
  fi: {
    ServiceCallApplyScene: {
      title: 'Hae huoltokutsuliittymää',
      save: 'Lähetä',
      businessId: 'Y-tunnus',
      officialName: 'Virallinen yritysnimi',
      streetAddress: 'Katuosoite',
      postalCode: 'Postinumero',
      city: 'Paikkakunta',
      contactName: 'Yhteyshenkilön nimi',
      phone: 'Puhelin',
      email: 'Sähköposti',
      chooseEmail: 'Valitse sähköposti',
      industry: 'Toimiala / kuvaus',
      personnelCount: 'Yrityksen henkilömäärä',
      submitSuccess: 'Hakemus lähetetty. Käsittelemme sen mahdollisimman pian.',
      accessActiveTitle: 'Käyttöoikeus aktiivinen',
      accessActiveText:
        'Yritykselläsi on jo huoltokutsuliittymän käyttöoikeus, joten uutta hakemusta ei tarvita.',
      accessPendingTitle: 'Hakemus käsittelyssä',
      accessPendingText:
        'Olet jo lähettänyt huoltokutsuliittymän hakemuksen. Ilmoitamme, kun se on käsitelty.',
      accessInactiveTitle: 'Käyttöoikeus poissa käytöstä',
      accessInactiveText:
        'Huoltokutsuliittymän käyttöoikeutesi on poistettu käytöstä, joten uutta hakemusta ei voi lähettää. Jos haluat aktivoida tilauksen uudelleen, ota yhteyttä asiakaspalveluun.',
      accessInactiveContact: 'Asiakaspalvelu',
      accessInactivePhoneLabel: 'Puh.',
      accessInactivePhone: '+358500747853',
      accessInactiveEmailLabel: 'Sähköposti',
      accessInactiveEmail: 'asiakaspalvelu@ajoneuvoni.fi',
    },
  },
};
